import Vue from "vue";
import VueRouter from "vue-router";
import PortalConnection from "../views/PortalConnection.vue";
import PortalDashboard from "../views/PortalDashboard.vue";
import NotFound from "@/components/error-pages/NotFound";
import Maintenance from "@/components/error-pages/Maintenance";
import store from "../store/index.js";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Login",
    component: PortalConnection,
  },
  {
    path: "/portal",
    name: "portal",
    redirect: "/Portal/Dashboard",
    component: () =>
      import(/* webpackChunkName: "portal" */ "../views/Portal.vue"),
    children: [
      {
        path: "/Portal/Dashboard",
        name: "PortalDashboard",
        component: PortalDashboard,
      },
    ],
    meta: {
      requiresAuth: true,
      isAuth: true,
    },
  },
  {
    path: "/redirect",
    beforeEnter() {
      // Put the full page URL including the protocol http(s) below
      //window.location.replace("https://www.chudequebec.ca");
    },
  },
  {
    path: "/maintenance",
    name: "maintenance",
    component: Maintenance,
  },
  {
    path: "/*",
    name: "NotFound",
    component: NotFound,
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (store.state.isAuthentified) {
      next();
    } else {
      next({
        path: "/",
        params: { nextUrl: to.fullPath },
      });
    }
  } else {
    next();
  }
});

export default router;
